// extracted by mini-css-extract-plugin
export default {"profit":"Profit_profit__A39ID","value":"Profit_value__DNJkS"};